import {TweenMax} from 'gsap';
import Colcade from 'colcade';

export default class MasonryController {
    constructor() {
        this.popup = document.querySelector('.js-popup');
        this.items = document.querySelectorAll('.js-masonry-item');
        this.popupOpened = false;
        this.body = document.querySelector('body');

        if (this.items.length > 0) {
            this.init();
            this.popupController(this.items);
            this.loadMore();
        }
    }

    init() {
        this.colc = new Colcade('.js-masonry-root', {
            columns: '.js-masonry-col',
            items: '.js-masonry-item'
        });

        const popupCloseBtns = document.querySelectorAll('.js-popup-close');
        if (popupCloseBtns.length > 0) {
            this.closePopupMethod(popupCloseBtns);
            this.openPopup();
        }
    }

    closePopup() {
        this.popupOpened = false;

        TweenMax.to(this.popup, 0.3, {
            autoAlpha: 0
        });

        this.unlockScroll();
    }

    loadMore() {

        const masonryRoot = jQuery('.js-masonry-root');
        const loadMoreBtn = document.querySelector('.js-load-more');
        let nextPageUrl = document.querySelector('.next-page-url');
        const loadMoreMessages = (event) => {
            event.preventDefault();

            jQuery.ajax({
                url: nextPageUrl.dataset.nextPageUrl,
                success: (response) => {
                    masonryRoot.append(response);

                    const newItems = document.querySelectorAll('.ajax-item');

                    this.colc.append(newItems);

                    this.popupController(newItems);

                    for (let item of newItems) {
                        item.classList.remove('ajax-item');
                    }

                    nextPageUrl.remove();
                    nextPageUrl = document.querySelector('.next-page-url');
                    if (nextPageUrl.dataset.nextPageUrl === '' && loadMoreBtn) {
                        loadMoreBtn.remove();
                    }
                },
            });
        };

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', loadMoreMessages);
        }
    }

    openPopup() {
        this.lockScroll();

        TweenMax.to(this.popup, 0.3, {
            autoAlpha: 1
        });

        this.popupOpened = true;
    }

    popupController(items) {

        for (let item of items) {
            item.addEventListener('click', (ev) => {
                ev.preventDefault();

                if (this.popupOpened) {
                    this.closePopup();
                    return;
                }

                jQuery.ajax({
                    url: item.dataset.url,
                    success: (response) => {
                        this.popup.innerHTML = response;
                        const popupCloseBtns = document.querySelectorAll('.js-popup-close');
                        this.closePopupMethod(popupCloseBtns);
                    },
                });

                this.openPopup();
            });
        }

        document.addEventListener('keypress', (e) => {
            if (e.key === "Escape") {
                if (this.popupOpened) {
                    this.closePopup();
                }
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === "Escape") {
                if (this.popupOpened) {
                    this.closePopup();
                }
            }
        });
    }

    closePopupMethod(popupCloseBtns) {
        for (let closeBtn of popupCloseBtns) {
            closeBtn.addEventListener('click', () => {
                if (this.popupOpened) {
                    this.closePopup();
                }
            });
        }
    }

    lockScroll() {
        this.offsetTop = document.documentElement.scrollTop;
        this.body.style.overflow = 'hidden';
        this.body.style.top = `-${document.documentElement.scrollTop}px`;
        this.body.style.position = 'fixed';

    }

    unlockScroll() {
        this.body.style.top = '0px';
        this.body.style.position = '';
        this.body.style.overflow = '';
        document.documentElement.scrollTop = this.offsetTop;
    }
}
